import welcomeArt from "../../assets/img/1 APP INTRO & FIRST LAUNCH/welcome-art-4x.webp";
import easterEggsArt from "../../assets/img/1 APP INTRO & FIRST LAUNCH/easter-eggs-art-4x.webp";
import dailyChallengesArt from "../../assets/img/1 APP INTRO & FIRST LAUNCH/daily-challenges-art-4x.webp";
import redeemArt from "../../assets/img/1 APP INTRO & FIRST LAUNCH/redeem-art-4x.webp";
import medalRookie from "../../assets/img/1 APP INTRO & FIRST LAUNCH/medal-rookie-4x.webp";
import medalPro from "../../assets/img/1 APP INTRO & FIRST LAUNCH/medal-pro-4x.webp";
import medalExpert from "../../assets/img/1 APP INTRO & FIRST LAUNCH/medal-expert-4x.webp";

export const INTRO_SLIDES = [
  {
    key: "welcome",
    art: welcomeArt,
    eyebrow: "GAMEZ ACADEMY",
    title: ["BECOME A PRO", "WIN REWARDS"],
    body: "Gaming guides, esports news and daily rewards — all in one place.",
    cta: "CONTINUE",
    showBack: false,
    showSkip: true,
    activeDot: 0,
  },
  {
    key: "easter-eggs",
    art: easterEggsArt,
    eyebrow: "YOUR CURRENCY",
    title: ["EASTER", "EGGS"],
    body: "Watch videos, listen to podcasts, play games — every activity drops an easter egg.",
    cta: "CONTINUE",
    showBack: true,
    showSkip: true,
    activeDot: 1,
  },
  {
    key: "daily-challenges",
    art: dailyChallengesArt,
    eyebrow: "DAILY MISSION",
    title: ["8", "CHALLENGES"],
    body: "Complete 8 missions a day — you earn a bonus egg and grow your streak.",
    cta: "CONTINUE",
    showBack: true,
    showSkip: true,
    activeDot: 2,
  },
  {
    key: "redeem",
    art: redeemArt,
    eyebrow: "REWARDS",
    title: ["WITH EGGS", "REWARDS"],
    body: "Turn the eggs you've collected into UC, Diamonds and Minecoins.",
    cta: "GET STARTED",
    showBack: true,
    showSkip: false,
    activeDot: 3,
  },
];

export const TIERS = [
  { name: "ROOKIE", range: "0 – 250", color: "#B8EE3C", medal: medalRookie, active: true, fill: 132 },
  { name: "PRO", range: "250 – 500", color: "#F9A825", medal: medalPro, active: false, fill: 0 },
  { name: "EXPERT", range: "500 – 750", color: "#9AA88A", medal: medalExpert, active: false, fill: 0 },
];
